// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media only screen and (min-width:992px){.guarantee-item{text-align:center}}.guarantee-item__ico{position:relative;width:48px;height:48px;margin:0 0 16px}@media only screen and (min-width:479px){.guarantee-item__ico{margin:0 auto 16px}}.guarantee-item__ico img{width:100%;height:100%;position:absolute;object-fit:cover}.guarantee-item__title{font-weight:700;font-size:16px;line-height:24px;margin-bottom:8px}.guarantee-item__text{font-size:14px;line-height:22px;color:var(--ud3x9j)}", ""]);
// Exports
module.exports = exports;
